/**
 * Created by dyc on 2018/4/22.
 */
import React from 'react';
import {hashHistory} from 'react-router'
import {DmsTab, TableView} from 'Components';
import {
    Button,
    Tabs,
    Table,
    Modal,
    Select,
    Input,
    Switch,
    Cascader,
    Row,
    Col,
    message,
    Card,
    Progress,
    Tooltip,
    Steps, Tag,
    Spin,
} from 'antd';
import './order.css';
import {formatMoney, openNotice, config} from 'Utils';
import {
    getOrderDetails,
    getShippedList,
    getstayList,
    getOrderApprove,
    orderPayConfirm,
    getOrderLog,
    getSendProduct,
    orderSendSave,
    getPayProve,
    getStorageAvailable,
    orderProPartDetails,
    waitForConfirm,
    specialPageLineList,
    specialHeadList,
    leaveFa,
    getOrderLineTrack,
    getEscrow,
    getEscrowDetail
} from '../../service/order';
import {getDictionay} from '../../service/product';
import moment from 'moment';

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const Step = Steps.Step;
const nodeType = {
    booked: '已登记',
    canceled: '已取消',
    scheduled: '排产中',
    inventory: '已入库',
    locked: '已锁库', // 注意，如果锁库的数量是0，则是取消锁库
    picked: '已拣货',
    shipped: '已发运',
    check: '已排产',
    begin: '已开工',
    complete: '已完工',
    transfer: '发往分物流'
};
const dayMap = {
    '0': '周日',
    '1': '周一',
    '2': '周二',
    '3': '周三',
    '4': '周四',
    '5': '周五',
    '6': '周六',
};
const productColum = [
    {'text': '序号', 'value': 'id'},
    {'text': '产品线', 'value': 'proLine'},
    {'text': '物料编码', 'value': 'productCode'},
    {'text': '物料描述', 'value': 'productName'},
    {'text': '牌价', 'value': 'originalPrice'},
    {'text': '单位', 'value': 'unit'},
    {'text': '参考库存', 'value': 'availableReferenceQuantity'},
    {'text': '开单数量', 'value': 'count'},
    {'text': '装箱数', 'value': 'packageQuantity'},
    {'text': '终端下浮', 'value': 'terminalPriceRate'},
    {'text': '终端单价', 'value': 'terminalUnitPrice'},
    {'text': '销售金额', 'value': 'sumprice'},
    {'text': '最大可接受数量', 'value': 'maxAcceptQty'},
    {'text': '生产周期（天）', 'value': 'productionCycle'},
    {'text': '物流周期（天）', 'value': 'logisticsCycle'},
    {'text': '参考到货期', 'value': 'referenceArrivalDate'},
    {'text': '预计到货期', 'value': 'predictArrivalDate'},
    {'text': '要求交期', 'value': 'deliveryArrivalDate'},
    {'text': '备注', 'value': 'remark'},
    {'text': '提货地点', 'value': 'pickProAddress'},
    {'text': '分批发运', 'value': 'orderProductPartList'},
    {'text': '审核终端价', 'value': 'checkPrice'},
    {'text': '终端审核意见', 'value': 'checkMsg'},
];

class ProductDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['订单详情 -- 项目订单'],
            loading: true,
            defaultActiveKey: 1,
            detailData: {},
            // orderNumber:'',
            editStatus: 'block',
            editStatus2: 'none',
            editStatus3: 'none',
            editStatus4: false,
            // orderRecord: [], // 订单操作日志
            logisticsArr: [], /* 物流公司 */
            loadingSend: false,
            visibleSend: false,
            visibleConfirmPay: false,
            loadingConfirmPay: false,
            payProveData: [],
            visibleApprove: false,
            loadingApprove: false,

            approveData: {
                auditOpinion: 1,
                auditRemark: ''
            },
            sendData: {
                'orderDeliveryItemList': [],
                'logisticsCompany': '',
                'logisticsCode': ''
            },
            confirmPayData: {
                id: '',
                confirmAmount: ''
            },
            /*待发货*/
            shippes: [],
            shippedTotal: 0,
            shippedObj: {
                s: 10,
                p: 1,
                code: this.props.routeParams.orderNumber
            },
            /*已发货*/
            stays: [],
            stayTotal: 0,
            stayObj: {
                s: 10,
                p: 1,
                orderNumber: this.props.routeParams.orderNumber
            },

            /*已取消*/
            cancel: [],
            cancelTotal: 0,
            cancelObj: {
                s: 10,
                p: 1,
                orderNumber: this.props.routeParams.orderNumber
            },
            /*托管未发*/
            escrow: [],
            escrowTotal: 0,
            escrowObj: {
                s: 10,
                p: 1,
                orderNumber: this.props.routeParams.orderNumber
            },
            /*托管已发*/
            escrowDetail: [],
            escrowDetailTotal: 0,
            escrowDetailObj: {
                s: 10,
                p: 1,
                orderNumber: this.props.routeParams.orderNumber
            },
            partialShipment: {
                visible: false,
                list: [],
                s: 10,
                p: 1,
                total: 0
            },
            visible4: false,
            selectedRowKeys5: [],
            addSearchObj: {
                s: 10,
                p: 1
            },
            zhiXiao: [],
            zhiXiaoObj: {
                // s: 10,
                // p: 1,
                orderNumber: this.props.routeParams.orderNumber
            },
            specialHeadData: {},
            /////////////
            hideColum: [],
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
        };
        this.getShipped = this.getShipped.bind(this);
        this.ShippedPageChange = this.ShippedPageChange.bind(this);
        this.getstay = this.getstay.bind(this);
        this.stayPageChange = this.stayPageChange.bind(this);
        this.getCancel = this.getCancel.bind(this);
        this.CancelPageChange = this.CancelPageChange.bind(this);
        this.getEscrow = this.getEscrow.bind(this);
        this.EscrowPageChange = this.EscrowPageChange.bind(this);
        this.getEscrowDetail = this.getEscrowDetail.bind(this);
        this.EscrowDetailPageChange = this.EscrowDetailPageChange.bind(this);

    }

    componentWillMount() {
        if (this.props.params.orderStatus == 1 || this.props.params.orderStatus == 4) {
            this.setState({editStatus: 'none', editStatus2: 'block'});
        }
        const id = this.props.params.orderId;
        getOrderDetails({id}).then(res => {
            if (res && res.code === 200) {
                this.setState({
                    orderDetail: res.data
                });
                window.sessionStorage.setItem('deliveryconfirmprint', JSON.stringify(res.data));
            }
        });

        // if (this.props..orderStatus)
        // this.initData(1);
    }

    /*待客户确认*/
    waitConfirm() {
        waitForConfirm({id: this.props.routeParams.orderId}).then(res => {
            // console.log(res)
            this.setState({editStatus4: true})
            if (res.code && res.code == 200) {
                openNotice('success', '确认成功');
                this.goView(`/order`)
            } else {
                openNotice('error', '确认失败');
                this.setState({editStatus4: false})
            }
        })
    }

    initData(key) {
        let orderId = this.props.routeParams.orderId;
        let self = this;

        /*获取订单详情*/
        getOrderDetails({id: orderId}).then(function (result) {
            self.setState({
                loading: true
            })
            if (result && result.code == 200) {
                let resultData = result.data || {};
                if (resultData.toBeConfirmedFlag == true) {
                    self.setState({editStatus: 'none', editStatus2: 'none', editStatus3: 'block'})
                }
                if (resultData.orderFalg == 0) {
                    self.setState({opts1: ' -- 代下单'})
                }
                if (resultData.pullChannel == 'CT') {
                    self.setState({pullChannel: '通讯能源'})
                }
                if (resultData.pullChannel == 'DL') {
                    self.setState({pullChannel: '电力'})
                }
                if (resultData.pullChannel == 'GMJ') {
                    self.setState({pullChannel: '建筑'})
                }
                if (resultData.pullChannel == 'PC') {
                    self.setState({pullChannel: '战略盘厂'})
                }
                resultData.productAmount = 0;
                resultData.promotionAmount = 0;
                for (let product of resultData.productList) {
                    if (product.promotionCount > 0) {
                        resultData.productAmount += product.originalPrice * product.count;
                    } else {
                        resultData.productAmount += product.price * product.count;
                    }
                    resultData.promotionAmount += product.price * product.count;
                }
                resultData.promotionAmount = (resultData.productAmount - resultData.promotionAmount).toFixed(2);
                self.setState({
                    'detailData': {
                        ...self.state.detailData,
                        ...resultData
                    },
                    loading: false,
                    orderNumber: resultData.code
                });
                // if (key) {
                //   getOrderLog(orderId).then(function (logResult) {
                //     if (logResult && logResult.code == 200) {
                //       logResult = logResult.data || [];
                //       // if (resultData.orderStatus == 4 || resultData.orderStatus == 5) {
                //       //   // 已取消 已完成
                //       // } else {
                //       //   logResult.push({
                //       //     'operation': resultData.sellerOrderStatusText,
                //       //     'createdDate': ''
                //       //   });
                //       // }
                //       self.setState({
                //         'orderRecord': logResult
                //       });
                //     } else {
                //       openNotice('error', '订单日志获取失败', (result && result.message) ? result.message : '');
                //     }
                //   });
                // }
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
                setTimeout(function () {
                    window.history.go(-1);
                }, 300);
            }
        });
    };

    /*已取消*/
    getCancel() {
        const self = this;
        const {cancelObj, orderNumber} = this.state;
        leaveFa({...cancelObj, orderNumber: orderNumber}).then(res => {
            const data = res.data || {};
            self.setState({
                cancel: data || [],
                cancelTotal: res.total
            })
        })
    };

    getEscrow() {
        const self = this;
        const {escrowObj, orderNumber} = this.state;
        getEscrow({...escrowObj, orderNumber: orderNumber}).then(res => {
            const data = res.data || {};
            self.setState({
                escrow: data || [],
                escrowTotal: res.total
            })
        })
    };

    getEscrowDetail() {
        const self = this;
        const {escrowDetailObj, orderNumber} = this.state;
        getEscrowDetail({...escrowDetailObj, orderNumber: orderNumber}).then(res => {
            const data = res.data || {};
            self.setState({
                escrowDetail: data || [],
                escrowDetailTotal: res.total
            })
        })
    };

    /*已取消翻页*/
    CancelPageChange(page, pageSize) {
        const self = this;
        this.setState({cancelObj: {...this.state.cancelObj, s: pageSize, p: page}}, function () {
            self.getCancel();
        });
    };

    EscrowPageChange(page, pageSize) {
        const self = this;
        this.setState({escrowObj: {...this.state.escrowObj, s: pageSize, p: page}}, function () {
            self.getEscrow();
        });
    };

    EscrowDetailPageChange(page, pageSize) {
        const self = this;
        this.setState({escrowDetailObj: {...this.state.escrowDetailObj, s: pageSize, p: page}}, function () {
            self.getEscrowDetail();
        });
    };

    /*待发货*/
    getShipped() {
        const self = this;
        const {shippedObj, orderNumber} = this.state;
        getShippedList({...shippedObj, code: orderNumber}).then(res => {
            const data = res.data || {};
            self.setState({
                shippes: data.data || [],
                shippedTotal: res.total
            })
        })
    };

    /*待发货翻页*/
    ShippedPageChange(page, pageSize) {
        const self = this;
        this.setState({shippedObj: {...this.state.shippedObj, s: pageSize, p: page}}, function () {
            self.getShipped();
        });
    };

    /*已发货*/
    getstay() {
        const self = this;
        const {stayObj, orderNumber} = this.state;
        getstayList({...stayObj, orderNumber: orderNumber}).then(res => {
            const data = res.data || {};
            self.setState({
                stays: data.data || [],
                stayTotal: res.total
            })
        })
    };

    /*已发货翻页*/
    stayPageChange(page, pageSize) {
        const self = this;
        this.setState({stayObj: {...this.state.stayObj, s: pageSize, p: page}}, function () {
            self.getstay();
        });
    };

    componentDidMount() {
        this.initData(1);
        let self = this;
        getDictionay('express_company').then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    logisticsArr: result.data || []
                });
            } else {
                openNotice('error', '物流公司获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    backTo() {
        window.history.go(-1);
    }

    /*评价*/
    evaluationRecord(record) {
        hashHistory.push('order/evaluate/' + record.orderId + '/' + record.id);
    }

    editOrder() {
        var x = this.props.routeParams.orderId;
        this.goView(`/order/addProject1/${9}&${x}`)
    }

    addAgain() {
        var x = this.props.routeParams.orderId;
        this.goView(`/order/addProject2/${9}&${x}&${'再来一单'}`)

    }

    tabClickFn(key) {
        /* 页签点击 */
        if (key === '2') {
            this.getShipped();
            this.getstay();
            this.getCancel();
            this.getEscrow();
            this.getEscrowDetail();
        }
        this.setState({defaultActiveKey: key});
    }

    /*showModal = () => {
     /!* 显示发货页面 *!/
     let orderId = this.props.routeParams.orderId;
     let self = this;
     getSendProduct(orderId).then(function (result) {
     let resultData = result.data || [];
     for (let send of resultData.productList) {
     send.storageLocal = [];
     send.count = 0; // 发货数量 默认 0
     }
     self.setState({
     visibleSend: true,
     sendData: {
     ...self.state.sendData,
     'orderDeliveryItemList': resultData.productList || [],
     'code': resultData.code,
     'logisticsCompany': '',
     'logisticsCode': ''
     }
     });
     });
     }*/
    handleSendOk = () => {
        this.setState({loadingSend: true});
        const {sendData, detailData} = this.state;
        let self = this;
        let params = {
            'orderDeliveryItemList': [],
            'code': sendData.code,
            'orderId': detailData.id,
            'logisticsCompany': sendData.logisticsCompany,
            'logisticsCode': sendData.logisticsCode
        };
        let orderDeliveryItemList = sendData.orderDeliveryItemList || [];
        for (let delivery of orderDeliveryItemList) {
            let storageLocal = delivery.storageLocal || [];
            if (delivery.count > 0 && storageLocal.length > 0) {
                params.orderDeliveryItemList.push({
                    'storageId': storageLocal[0], /* 仓库ID */
                    'storageLocalId': storageLocal.length == 2 ? storageLocal[1] : '', /* 货位 */
                    'orderId': delivery.orderId,
                    'productId': delivery.productId,
                    'orderProductId': delivery.id,
                    'availableCount': '', // 仓库可用量
                    'count': delivery.count /* 发货数量 */
                });
            }
        }
        if (params.orderDeliveryItemList.length == 0) {
            openNotice('warning', '验证', '请选择仓库-货位,请输入发货数量');
            this.setState({loadingSend: false});
            return;
        }
        orderSendSave(params).then(function (result) {
            if (result && result.code == 200) {
                self.setState({loadingSend: false, visibleSend: false});
                self.initData(1);
                openNotice('success', '发货操作成功', '');
            } else {
                self.setState({loadingSend: false});
                openNotice('error', '发货操作失败', (result && result.message) ? result.message : '');
            }
        });
    }
    handleSendCancel = () => {
        this.setState({visibleSend: false, loadingSend: false});
    }

    changeInputSendFn(index, field, value) {
        let val = value;
        let self = this;
        if (value.target) {
            val = value.target.value || '';
        }
        if (index == -1) {
            this.setState({
                'sendData': {
                    ...this.state.sendData,
                    [field]: val
                }
            });
            return;
        }
        let orderDeliveryItemList = this.state.sendData.orderDeliveryItemList || [];
        if (field == 'count') {
            if (!orderDeliveryItemList[index].availableCount || orderDeliveryItemList[index].availableCount == 0) {
                openNotice('warning', '验证', '请选择仓库-货位！');
                return;
            }
            if (orderDeliveryItemList[index].availableCount < val) {
                val = orderDeliveryItemList[index].availableCount;
            }
            if (orderDeliveryItemList[index].undeliveredCount < val) {
                val = orderDeliveryItemList[index].undeliveredCount;
            }
        }
        orderDeliveryItemList[index][field] = val;
        if (field == 'storageLocal' && val.length > 0) {
            let params = {
                'productId': orderDeliveryItemList[index].productId,
                'productSpecId': orderDeliveryItemList[index].productSpecId,
                'storage': val[0],
                'storageLocal': val.length > 1 ? val[1] : ''
            };
            getStorageAvailable(params).then(result => {
                if (result && result.code == 200) {
                    let availableCount = result.data || 0;
                    if (availableCount == 0) {
                        orderDeliveryItemList[index][field] = [];
                        openNotice('warning', '验证', '该仓库-货位上没有该产品，请重新选择！');
                    }
                    if (availableCount < orderDeliveryItemList[index]['count']) {
                        openNotice('warning', '验证', '该仓库-货位上的产品库存小于发货数量！');
                        orderDeliveryItemList[index]['count'] = availableCount;
                    }
                    orderDeliveryItemList[index]['availableCount'] = availableCount;
                    self.setState({
                        'sendData': {
                            ...this.state.sendData,
                            'orderDeliveryItemList': orderDeliveryItemList
                        }
                    });
                }
            });
        } else {
            this.setState({
                'sendData': {
                    ...this.state.sendData,
                    'orderDeliveryItemList': orderDeliveryItemList
                }
            });
        }
    }

    approveFn() {
        /* 订单审核 */
        this.setState({
            visibleApprove: true,
            approveData: {
                ...this.state.approveData,
                'auditOpinion': 1,
                'auditRemark': ''
            }
        });
    }

    handleApproveOk = () => {
        let self = this;
        self.setState({loadingApprove: true});
        let params = self.state.approveData;
        params.id = self.state.detailData.id;
        params.auditOpinion = params.auditOpinion ? 1 : 0;
        /* 订单审核接口 */
        getOrderApprove(params).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    loadingApprove: false,
                    visibleApprove: false
                });
                self.initData(1);
            } else {
                self.setState({loadingApprove: false});
                openNotice('error', '订单审核操作失败', (result && result.message) ? result.message : '');
            }
        });
    };

    handleApproveCancel = () => {
        this.setState({visibleApprove: false, loadingApprove: false});
    }

    changeApproveFn(field, value) {
        this.setState({
            'approveData': {
                ...this.state.approveData,
                [field]: typeof value == 'object' ? value.target.value : value
            }
        });
    }

    showConfirmPayModal = (id) => {
        /* 显示确认收款页面 */
        let self = this;
        self.setState({
            visibleConfirmPay: true,
            confirmPayData: {
                ...this.state.confirmPayData,
                'id': id,
                'confirmAmount': ''
            }
        });
        getPayProve(id).then(result => {
            if (result && result.code == 200) {
                self.setState({
                    'payProveData': result.data.picFileList || []
                });
            } else {
                openNotice('error', '付款证明获取失败', (result && result.message) ? result.message : '');
                self.setState({
                    visibleConfirmPay: false
                });
            }
        });
    }

    changeConfirmPayFn(field, value) {
        /* 收款确认 input */
        this.setState({
            'confirmPayData': {
                ...this.state.confirmPayData,
                [field]: typeof value == 'object' ? value.target.value : value
            }
        });
    }

    handleConfirmPayCancel() {
        this.setState({visibleConfirmPay: false, loadingConfirmPay: false});
    }

    /*确认金额*/
    handleConfirmPayOk() {
        let self = this;
        const {confirmPayData} = self.state;
        if (!confirmPayData.confirmAmount) {
            openNotice('warning', '请输入确认金额', '');
            return;
        }
        self.setState({loadingConfirmPay: true});
        let params = {
            'confirmAmount': confirmPayData.confirmAmount,
            'id': confirmPayData.id
        };
        orderPayConfirm(params).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    loadingConfirmPay: false,
                    visibleConfirmPay: false
                });
                self.initData();
            } else {
                self.setState({loadingConfirmPay: false});
                openNotice('error', '确认收款失败', (result && result.message) ? result.message : '');
            }
        });
    }

    returnConfirmAmount(datas, key) {
        // 计算待确认款项\实收金额
        let amount = 0;
        for (let data of datas) {
            if (key == 'no') {
                // 待确认款项
                amount += data.amount - data.confirmAmount;
            } else {
                // 实收金额
                amount += data.confirmAmount;
            }
        }
        return formatMoney(amount);
    }

    openImg(url) {
        window.open(config.server + url);
    }

    showPartList(record) {
        this.setState({
            partialShipment: {...this.state.partialShipment, visible: true}
        });
        orderProPartDetails({
            orderId: record.orderId,
            orderProductId: record.productId,
            s: this.state.partialShipment.s,
            p: this.state.partialShipment.p
        }).then(res => {
            if (res.code === 200) {
                this.setState({
                    partialShipment: {...this.state.partialShipment, list: res.data || []},
                    total: res.total
                });
            }
        });
    }

    handleOk() {
        const {partialShipment} = this.state;
        this.setState({
            partialShipment: {...partialShipment, visible: false}
        });
    }

    openSpecialModal() {
        this.setState({visible4: true});
        this.getAddArray5();
    }

    getAddArray5 = () => {
        var addSearchObj = {...this.state.addSearchObj};
        addSearchObj.specCode = this.state.detailData.specialOfferCode;
        specialPageLineList(addSearchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows5: result.data,
                    addTotal5: result.total,
                    addSearchObj: addSearchObj
                });
            } else {
                openNotice('error', '获取特价信息失败');
            }
        })
        specialHeadList({
            specCode: this.state.detailData.specialOfferCode,
            contractId: this.state.detailData.contractId
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    specialHeadData: result.data,
                });
            } else {
                openNotice('error', '获取特价信息失败');
            }
        })

    }
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getAddArray5();
        });
    };

    addSaveHandler4() {
        this.setState({visible4: false});
    }

    /*导出*/
    exportText() {
        var id = this.state.detailData.id;
        window.location.href = `${config.server}/api/v1/dms/tgOrder/exportOrderDetail/${id}`;
    }

    /*收货确认单打印按钮*/
    deliveryConfirmPrint() {
        window.open('/pcweb/#/deliveryConfirmPrint')
        // window.open('/#/returnGoodsPrint')
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    openInfo = (info) => {
        const rowKey = info.id;
        let {orderLineTracks, expandedRowKeys, trackLoadingId} = this.state;
        if (trackLoadingId === rowKey) {
            return;
        }
        if (expandedRowKeys.includes(rowKey)) {
            this.setState({
                expandedRowKeys: expandedRowKeys.filter(x => x !== rowKey),
                trackLoadingId: null,
            });
            return;
        }
        if (orderLineTracks[rowKey]) {
            this.setState({expandedRowKeys: [rowKey]});
            return;
        }
        if (!info.lineId) {
            message.error('缺少参数lineId，无法获取跟踪记录！！');
            return;
        }
        this.setState({trackLoadingId: rowKey, expandedRowKeys: []});
        getOrderLineTrack(info.lineId).then(res => {
            if (res.status) {
                let data = res.data;
                data.track = (data.track || []).filter(x => !!x.TRANSACTION_DATE && /\d{10}/.test(x.TRANSACTION_DATE)).map(x => {
                    let d = new Date(parseInt(x.TRANSACTION_DATE, 10) * 1000);
                    return {
                        date: d.format('yyyy-MM-dd'),
                        day: dayMap[d.getDay()],
                        time: d.format('hh:mm:ss'),
                        type: nodeType[x.TYPE],
                        msg: x.MESSAGE,
                        timestamp: d.getTime(),
                    };
                });
                let gpsTracks = [];
                (data.gps || []).forEach((item) => {
                    gpsTracks.push([item.longitude, item.latitude]);
                });
                this.setState({
                    orderLineTracks: {
                        ...this.state.orderLineTracks,
                        [rowKey]: data,
                        gpsTracks: gpsTracks,
                    },
                    expandedRowKeys: [rowKey],
                    trackLoadingId: null,
                });
            } else {
                openNotice('error', res.message || '获取跟踪记录失败');
                this.setState({trackLoadingId: null});
            }
        }).catch(() => {
            openNotice('error', '获取跟踪记录失败');
            this.setState({trackLoadingId: null});
        });
    };

    render() {
        const {
            opts, specialHeadData, zhiXiao, zhiXiaoObj,
            defaultActiveKey, detailData, visibleSend, loadingSend,
            visibleApprove, loadingApprove, approveData,
            sendData, visibleConfirmPay, loadingConfirmPay,
            confirmPayData, logisticsArr, payProveData,
            orderRecord, shippes, shippedTotal, shippedObj,
            stays, stayTotal, stayObj, partialShipment, cancel,
            cancelTotal, cancelObj, editStatus,
            editStatus2, editStatus3, editStatus4, addRows5, loading,
            addTotal5, addSearchObj, visible4,
            orderLineTracks, expandedRowKeys, hideColum, filterKeyword, trackLoadingId,
            escrowTotal, escrowObj, escrow, escrowDetailTotal, escrowDetailObj, escrowDetail
        } = this.state;
        let self = this;
        const addProps5 = {
            rowKey: 'id',
            pageParam: {
                total: addTotal5,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '具体物料规格',
                    children: [{
                        title: '对应物料编码',
                        dataIndex: 'proCode',
                        width: 100
                    },
                        {
                            title: '具体物料描述',
                            dataIndex: 'proDesc',
                            width: 100,
                        },
                        {
                            title: '产品数量',
                            dataIndex: 'count',
                            width: 100,
                        },
                        {
                            title: '面价',
                            dataIndex: 'listPrice',
                            width: 100,
                        },
                        {
                            title: '合同价',
                            dataIndex: 'price',
                            width: 100,
                        }, {
                            title: '总金额(万元)',
                            dataIndex: 'amount',
                            width: 100,
                        }]
                },
                {
                    title: '整体框架协议',
                    children: [{
                        title: '产品类别',
                        dataIndex: 'categoryDesc',
                        width: 100,
                    },
                        {
                            title: '类别编码',
                            dataIndex: 'categoryCode',
                            width: 100,
                        },
                        {
                            title: '合同下浮比例',
                            dataIndex: 'lowerRate',
                            width: 100,
                        }]
                }
            ],
            dataSource: addRows5,
            // rowSelection: {
            //   selectedRowKeys:selectedRowKeys5,
            //   onChange: this.onSelectChange5,
            //   onSelect:this.onSelectRadio5,
            //   type: 'radio',
            // }
        };
        const productProps = {
            loading: loading,
            rowKey: 'id',
            scroll: {x: 1000, y: false},
            className: 'order-product-list',
            columns: [
                {
                    title: '序号',
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return index + 1
                    }
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    render: (text) => {
                        switch (text) {
                            case '01' || '元器件':
                                return <span>{'元器件'}</span>;
                                break;
                            case '02' || '电工':
                                return <span>{'电工'}</span>;
                                break;
                            case '03' || '电表':
                                return <span>{'电表'}</span>;
                                break;
                            case '04' || '变频器':
                                return <span>{'变频器'}</span>;
                                break;
                            case '05' || '天e':
                                return <span>{'天e'}</span>;
                                break;
                            case '06' || 'TG精品':
                                return <span>{'TG精品'}</span>;
                                break;
                        }
                    }
                },
                {
                    title: '物料编码',
                    dataIndex: 'productCode',
                    width: 120,
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text} &nbsp;
                                    {record.specialShipFlag ?
                                        <Tag color="green">直发物料</Tag> : null}
                                    </span>
                            </div>
                        )
                    }
                },
                {
                    title: '物料描述',
                    dataIndex: 'productName'
                },
                {
                    title: '牌价',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '参考库存',
                    dataIndex: 'availableReferenceQuantity',
                    render: (text, record, index) => {
                        return (
                            <span>{record.noshowOnhand ? '*' : text}</span>
                        );
                    }
                },
                {
                    title: '开单数量',
                    dataIndex: 'count'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                // 根据客户要求隐藏后又恢复显示
                {
                    title: '终端下浮',
                    dataIndex: 'terminalPriceRate'
                },
                {
                    title: '终端单价',
                    dataIndex: 'terminalUnitPrice'
                },
                {
                    title: '销售金额',
                    dataIndex: 'sumprice',
                    render: (text, record, index) => (
                        <div>{(record.checkPrice ? record.checkPrice * record.count : record.terminalUnitPrice * record.count).toFixed(2)}</div>
                    )
                },
                {
                    title: '最大可接受数量',
                    dataIndex: 'maxAcceptQty',
                },
                {
                    title: <Tooltip title="例如生产周期为[1,3]表示：类型为库存类的产品，有库存时生产需要1天，无库存时生产需要3天。
类型为非库存类的产品，显示为准确的生产天数">生产周期（天）</Tooltip>,
                    dataIndex: 'productionCycle',
                    render: (text, record, index) => {
                        // console.log(record.productionCycle);
                        if (record.productionCycle || ''.includes("[")) {
                            return <Tooltip title="有库存天数/无库存天数">{record.productionCycle}</Tooltip>
                        }
                        return <span>{record.productionCycle}</span>
                    }
                },
                {
                    title: <Tooltip title="例：物流周期：[2,6]代表：有库存物流发货:2天，无库存:6天">物流周期（天）</Tooltip>,
                    dataIndex: 'logisticsCycle',
                    render: (text, record, index) => {
                        // console.log(record.productionCycle);
                        if (record.logisticsCycle || ''.includes("[")) {
                            return <Tooltip title="有库存天数/无库存天数">{record.logisticsCycle}</Tooltip>
                        }
                        return <span>{record.logisticsCycle}</span>
                    }
                },
                {
                    title: '参考到货期',
                    dataIndex: 'referenceArrivalDate',
                    render: text => {
                        if (typeof text == 'string') {
                            if (text == '待评审') {
                                return (<span style={{color: 'red'}}>{text}</span>);
                            } else {
                                return text;
                            }
                        } else {
                            text ? new Date(text).format('yyyy-MM-dd') : ''
                        }
                    }
                },
                // {
                //     title: '预计到货期',
                //     dataIndex: 'predictArrivalDate',
                //     render: text => {
                //         if (typeof text == 'string') {
                //             return text
                //         } else {
                //             text ? new Date(text).format('yyyy-MM-dd') : ''
                //         }
                //     }
                // },
                {
                    title: '要求交期',
                    dataIndex: 'deliveryArrivalDate',
                    render: text => {
                        const str = text ? moment(text).format('yyyy-MM-DD') : '';
                        return (<span>{str}</span>);
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '提货地点',
                    dataIndex: 'pickProAddress'
                },
                /*{
                    title: '分批发运',
                    dataIndex: 'orderProductPartList',
                    render: (text, record, index) => (
                        <Button size={'small'} onClick={self.showPartList.bind(self, record)}>查看</Button>
                    )
                },*/
                {
                    title: '审核终端价',
                    dataIndex: 'checkPrice'
                },
                {
                    title: '终端审核意见',
                    dataIndex: 'checkMsg'
                },
                /*{
                    title: '操作',
                    dataIndex: 'action',
                    render: (text, record, index) => (
                        record.commentFlag ?
                            <Button size={'small'} onClick={self.evaluationRecord.bind(self, record)}>评价</Button> :
                            <span>暂无操作</span>
                    )
                }*/
            ],

            dataSource: !!filterKeyword ? (detailData.productList || []).filter(x => (x.productCode.indexOf(filterKeyword) > -1 || x.productName.indexOf(filterKeyword) > -1)) : detailData.productList || [],
            expandedRowKeys: expandedRowKeys,
            onExpand: (expanded, record) => this.openInfo(record),
            expandedRowRender: (record) => {
                if (!orderLineTracks[record.id]) return null;
                const info = orderLineTracks[record.id] || {};
                const quantity = info.quantity || {};

                const script = document.createElement("script");
                script.src = `https://webapi.amap.com/maps?v=2.0&key=348a4830947424baf8327c22d1386067`;
                script.async = true;
                document.head.appendChild(script);
                const trailCoordinates = orderLineTracks.gpsTracks;
                console.log(trailCoordinates)

                if (trailCoordinates.length > 0) {
                    script.onload = () => {
                        // 初始化地图
                        const map = new AMap.Map("map-container", {
                            zoom: 13, // 初始缩放级别
                            center: [116.397428, 39.90923], // 初始中心点
                        });

                        // 绘制轨迹线
                        const polyline = new AMap.Polyline({
                            path: trailCoordinates, // 轨迹路径
                            strokeWeight: 5, // 线宽
                            strokeColor: "#800080", // 线颜色
                            lineJoin: "round", // 折线拐点样式
                        });
                        map.add(polyline);

                        // 添加起点和终点标记
                        trailCoordinates.forEach((coord, index) => {
                            new AMap.Marker({
                                position: coord,
                                content: `<div style="background-color: ${
                                    index === 0 ? "#00FF00" : "#FF0000"
                                }; width: 10px; height: 10px; border-radius: 50%; display: ${index === 0 || index == trailCoordinates.length - 1 ? "block" : "none"};"></div>`, // 起点绿色，终点红色
                            }).addTo(map);
                        });

                        // 调整地图视野以适应轨迹
                        map.setFitView();
                    };
                }

                return (<div>
                    {/*<p className="track-bref">计划中：{quantity.PLAN_QUANTITY || 0}&emsp;&emsp;生产中：{quantity.SCHEDULED_QUANTITY || 0}&emsp;&emsp;已锁库：{quantity.LOCKED_QUANTITY || 0}&emsp;&emsp;已发货：{quantity.SHIPPED_QUANTITY || 0}</p>*/}
                    <p className="track-bref">订单跟踪详情</p>
                    <Row gutter={16}>
                        <Col span={4}>
                            {!!record.commentFlag &&
                                <Button size="large" className="mb-20"
                                        onClick={self.evaluationRecord.bind(self, record)}>评价</Button>}
                            <p>订单：{detailData.code}</p>
                        </Col>
                        <Col span={20} style={{padding: '0 15px', borderLeft: 'solid 1px #ddd'}}>
                            <Steps className="dms-steps">
                                <Step
                                    status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 || quantity.PLAN_QUANTITY > 0 || quantity.ORDERED_QUANTITY > 0 ? 'finish' : 'wait'}
                                    title="订单登记"
                                    description={`数量 ${quantity.ORDERED_QUANTITY}`}
                                    icon={<span className="tengen icon-dengji"/>}/>
                                <Step
                                    status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 || quantity.PLAN_QUANTITY > 0 ? 'finish' : 'wait'}
                                    title="接单处理"
                                    description={`数量 ${quantity.PLAN_QUANTITY}`}
                                    icon={<span className="tengen icon-storage"/>}/>
                                <Step
                                    status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 ? 'finish' : 'wait'}
                                    title="车间生产"
                                    description={`数量 ${quantity.SCHEDULED_QUANTITY}`}
                                    icon={<span className="tengen icon-product"/>}/>
                                <Step
                                    status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 ? 'finish' : 'wait'}
                                    title="锁库待发"
                                    description={`数量 ${quantity.LOCKED_QUANTITY}`}
                                    icon={<span className="tengen icon-ruku"/>}/>
                                <Step
                                    status={quantity.SHIPPED_QUANTITY > 0 ? 'finish' : 'wait'}
                                    title="发运出库"
                                    description={`数量 ${quantity.SHIPPED_QUANTITY}`}
                                    icon={<span className="tengen icon-fahuo"/>}/>
                            </Steps>
                            <div className="dms-split-bar"></div>
                            <div className="time-line">
                                {info.track.map((x, index, arr) => <div key={index}>
                                    <div className="item">
                                        <p>
                      <span>
                          <span className="date">{x.date}/{x.day}</span>
                          <span className="time">{x.time}</span>
                          <span className={`dot${index === 0 ? ' last' : ''}`}>◉</span>
                      </span>
                                            <b>{x.type}</b>
                                        </p>
                                        <p>{x.msg}</p>
                                    </div>
                                </div>)}
                            </div>
                        </Col>
                    </Row>
                    <Row style={{display: trailCoordinates.length > 0 ? 'block' : 'none'}}><p
                        className="track-bref">货物运输轨迹</p></Row>
                    <Row style={{display: trailCoordinates.length > 0 ? 'block' : 'none'}}>
                        <div
                            id="map-container"
                            style={{width: "100%", height: "300px"}} // 地图容器样式
                        />
                    </Row>
                </div>);
            },
        };
        if (hideColum && hideColum.length > 0) {
            productProps.columns = productProps.columns.filter(x => !hideColum.includes(x.dataIndex));
        }
        // 有erp订单号，才能够查看订单跟踪详情
        if (detailData && !!detailData.code) {
            productProps.columns.push({
                title: '订单跟踪',
                dataIndex: 'action',
                width: 60,
                render: (text, record, index) => (
                    trackLoadingId === record.id
                        ? <Spin size="small"/>
                        : <a onClick={() => this.openInfo(record)}>详情</a>
                ),
            })
        }
        const shippedProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: shippedTotal,
                current: shippedObj.p,//当前页码
                pageSize: shippedObj.s,//当前分页数
                onChange: this.ShippedPageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'ITEM_DESC'
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM'
                }, {
                    title: '单位',
                    dataIndex: 'UNIT'
                }, {
                    title: '待发数量/订单数量/库存锁定数量',
                    dataIndex: 'WAIT_QUALITY',
                    render: (text, record, index) => {
                        return <span>{`${record.WAIT_QUALITY}/${record.ORDERED_QUANTITY}/${record.LOCK_QUANTITY}`}</span>
                    }
                }, {
                    title: '待发金额（元）',
                    dataIndex: 'WAIT_AMOUNT',
                }
            ],
            rows: shippes,
        };
        const cancelProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: cancelTotal,
                current: cancelObj.p,//当前页码
                pageSize: cancelObj.s,//当前分页数
                onChange: this.CancelPageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'ORDER_NUMBER',
                },
                {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM',
                },
                {
                    title: '物料描述',
                    dataIndex: 'ITEM_DESC',
                },
                {
                    title: '单位',
                    dataIndex: 'UNIT',
                },
                {
                    title: '取消数量',
                    dataIndex: 'CANCELLED_QUANTITY',
                },
                {
                    title: '取消金额',
                    dataIndex: 'CANCELLED_AMOUNT',
                }
            ],
            rows: cancel,
        };

        const escrowProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: escrowTotal,
                current: escrowObj.p,//当前页码
                pageSize: escrowObj.s,//当前分页数
                onChange: this.EscrowPageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'ITEM_DESC'
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM'
                }, {
                    title: '单位',
                    dataIndex: 'UNIT'
                }, {
                    title: '订单数量',
                    dataIndex: 'ORDERED_QUANTITY'
                }, {
                    title: '在途数量',
                    dataIndex: 'ZT_QUANTITY'
                }, {
                    title: '入库数量',
                    dataIndex: 'RK_QUANTITY'
                }, {
                    title: '未发数量',
                    dataIndex: 'UN_SHIP_QUANTITY'
                }
            ],
            rows: escrow,
        };

        const escrowDetailProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: escrowDetailTotal,
                current: escrowDetailObj.p,//当前页码
                pageSize: escrowDetailObj.s,//当前分页数
                onChange: this.EscrowDetailPageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'ITEM_DESC'
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM'
                }, {
                    title: '单位',
                    dataIndex: 'UNIT'
                }, {
                    title: '发货数量',
                    dataIndex: 'ZT_QUANTITY',
                    render: (text, record, index) => {
                        return (<div>{record.ZT_QUANTITY + record.RK_QUANTITY}</div>)
                    }
                }, {
                    title: '转移单号',
                    dataIndex: 'TXN_NUMBER'
                }, {
                    title: '发出时间',
                    dataIndex: 'TRANSACTION_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                }, {
                    title: '接收时间',
                    dataIndex: 'RECE_TRANSACTION_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                }
            ],
            rows: escrowDetail,
        };

        const stayProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: stayTotal,
                current: stayObj.p,//当前页码
                pageSize: stayObj.s,//当前分页数
                onChange: this.stayPageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'ITEM_DESC'
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM'
                }, {
                    title: '单位',
                    dataIndex: 'UNIT'
                }, {
                    title: '发货数量',
                    dataIndex: 'SHIPPED_QUANTITY'
                }, {
                    title: '发货子库',
                    dataIndex: 'SUBINVENTORY'
                }, {
                    title: '出库单号',
                    dataIndex: 'DELIVERY_ID'
                }, {
                    title: '发货日期',
                    dataIndex: 'CONFIRM_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                }, {
                    title: '收货日期',
                    dataIndex: 'RECEIPT_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                },
                {
                    title: '配送物流公司',
                    dataIndex: 'logisticsCompany'
                },
                {
                    title: '物流联系电话',
                    dataIndex: 'logisticsPhone'
                },
                {
                    title: '核销状态',
                    dataIndex: 'RELEASED_STATUS'
                },
            ],
            rows: stays,

        };
        const sendProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '产品名称',
                    dataIndex: 'productName'
                }, {
                    title: '规格',
                    dataIndex: 'specUnionKey'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '待发数量',
                    dataIndex: 'undeliveredCount'
                }, {
                    title: '发货仓库-货位',
                    dataIndex: 'storageLocal',
                    render: (text, record, index) => {
                        return <div id={'storageLocal' + index}>
                            <Cascader getPopupContainer={() => document.getElementById('storageLocal' + index)}
                                      value={text}
                                      onChange={this.changeInputSendFn.bind(this, index, 'storageLocal')}
                                      options={record.storageList || []} placeholder="请选择仓库-货位"/>
                        </div>
                    }
                }, {
                    title: '可用量',
                    dataIndex: 'availableCount'
                }, {
                    title: '发货数量',
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return <Input type="number" value={text}
                                      onChange={this.changeInputSendFn.bind(this, index, 'count')}
                                      placeholder="请输入发货数量"/>
                    }
                }
            ],
            dataSource: sendData.orderDeliveryItemList || []
        };
        const tgOrderRecords = detailData.tgOrderRecords || [];
        let orderRecordHtml = tgOrderRecords.map(function (qst, key) {
            if (qst.operation == "异常") {
                return <a
                    className={(key == (tgOrderRecords.length - 1) && !(detailData.orderStatus == 4 || detailData.orderStatus == 5)) ? '' : 'already'}
                    key={key}>
                    <Progress className="index" type="circle" percent={70} format={() => key + 1} width={50}
                              status="exception"></Progress>
                    <p className="f">{qst.promissMsg}</p>
                    <p className="f">{qst.message}</p>
                    <p className={qst.createdDate ? '' : 'no'}>{new Date(qst.createdDate).format('yyyy-MM-dd HH:mm:ss')}</p>
                    <span style={{display: key == (tgOrderRecords.length - 1) ? 'none' : 'inline-block'}}
                          className="l"></span>
                </a>
            }
            return <a
                className={(key == (tgOrderRecords.length - 1) && !(detailData.orderStatus == 4 || detailData.orderStatus == 5)) ? '' : 'already'}
                key={key}>
                <Progress className="index" type="circle" percent={100} format={() => key + 1} width={50}></Progress>
                <p className="f">{qst.promissMsg}</p>
                <p className="f">{qst.message}</p>
                <p className={qst.createdDate ? '' : 'no'}>{new Date(qst.createdDate).format('yyyy-MM-dd HH:mm:ss')}</p>
                <span style={{display: key == (tgOrderRecords.length - 1) ? 'none' : 'inline-block'}}
                      className="l"></span>
            </a>
        });
        let logisticsHtml = logisticsArr.map(function (qst, key) {
            return <Option key={key} value={qst.sKey}>{qst.name}</Option>;
        });
        let payProveHtml = payProveData.map((qst, key) => {
            return <img alt="" key={key} src={config.server + qst.fileCompressPath}
                        onClick={this.openImg.bind(this, qst.filePath)}/>
        });
        const partialShipmentProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '约定发货日期',
                    dataIndex: 'appointDeliveryDate',
                    render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : ''
                },
                {
                    title: '默认发货周期(天)',
                    dataIndex: 'logisticsCycle'
                }, {
                    title: '发货数量',
                    dataIndex: 'deliveryCount'
                },
                {
                    title: '物料名称',
                    dataIndex: 'productName'
                },

            ],
            dataSource: partialShipment.list
        };
        const partialShipmentPagination = {
            total: partialShipment.total,
            onChange: (page) => {
                this.setState({
                    partialShipment: {...partialShipment, p: page}
                }, () => {
                    this.showPartList();
                });
            }
        };

        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <span style={{
                    color: '#ccc',
                    fontSize: '12px',
                    float: 'left',
                    marginTop: '5px',
                    marginLeft: '-728px',
                }}>{this.state.opts1 || ''}</span>
                {/*<Button onClick={this.approveFn.bind(this)} style={{*/}
                {/*background: '#d61518',*/}
                {/*color: '#fff',*/}
                {/*display: (detailData.orderStatus == 1) ? 'inline-block' : 'none'*/}
                {/*}}>审核</Button>*/}
                {/*<Button style={{ background: '#d61518', color: '#fff' }}>确认</Button>*/}
                <Button style={{
                    display: (detailData.erpStatus === '已登记') ? 'block' : 'none',
                    float: 'left',
                    background: '#d61518',
                    color: '#f2f7fb'
                }} onClick={this.deliveryConfirmPrint.bind(this)}>收货确认单</Button>
                <Button onClick={this.backTo.bind(this)} style={{marginRight: 5, float: 'right'}}>返回</Button>
                <Button
                    style={{background: '#d61518', color: '#fff', display: editStatus2, marginRight: 5, float: 'right'}}
                    onClick={this.editOrder.bind(this)}>编辑</Button>
                <Button
                    style={{background: '#d61518', color: '#fff', display: editStatus, marginRight: 5, float: 'right'}}
                    onClick={this.addAgain.bind(this)}>再来一单</Button>
                <Button
                    style={{background: '#d61518', color: '#fff', display: editStatus3, marginRight: 5, float: 'right'}}
                    onClick={this.waitConfirm.bind(this)} disabled={editStatus4}>代下单确认</Button>
                <Button style={{background: '#d61518', color: '#fff', marginRight: 5, float: 'right'}}
                        onClick={this.exportText.bind(this)}>导出
                    {/*<a href={`${config.server}/api/v1/dms/tgOrder/exportOrderDetail/${detailData.id}`} target="blank">导出</a>*/}
                </Button>
                {/*<Button style={{background:'#d61518', color: '#fff', display: (!(detailData.orderStatus==1 || detailData.orderStatus==5) && detailData.undeliveredList && detailData.undeliveredList.length > 0)?'inline-block':'none'}} onClick={self.showModal.bind(self)}>发货</Button>*/}
            </DmsTab>
            <div className="dms-table-box" style={{padding: '0'}}>
                <Row>
                    <Col span={6}>
                        <Card title="订单信息" bordered={false} noHovering={true}>
                            <p><label>要货单号：</label><span>{detailData.getProCode}</span></p>
                            <p><label>订单编号：</label><span>{detailData.code || '-'}</span></p>
                            <p>
                                <label>订单日期：</label><span>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</span>
                            </p>
                            <p><label>订单类型：</label><span>{detailData.orderTypeStr}</span></p>
                            <p><label>状态：</label><span>{detailData.erpStatus}</span></p>
                            <p><label>EBS订单状态：</label><span>{detailData.orderBackMsg || '-'}</span></p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="客户资料" bordered={false} noHovering={true}>
                            <p><label>经销商编号：</label><span>{detailData.customerCode}</span></p>
                            <p><label>经销商名称：</label><span>{detailData.customerName}</span></p>
                            <p><label>购货单位：</label><span>{detailData.buyCompany}</span></p>
                            <p><label>渠道：</label><span>{detailData.channel}</span></p>
                            <p>{/*<label
                                style={{display: (detailData.channelCode == 'PC' || detailData.channelCode == 'FX') ? 'inline-block' : 'none'}}>承接</label>*/}
                                <label>承接业务员：</label><span>{detailData.salesmanName || '-'}</span>
                            </p>
                            {/*<p style={{display: (detailData.channelCode == 'PC' || detailData.channelCode == 'FX') ? 'inline-block' : 'none'}}>*/}
                            <p>
                                <label>拉动业务员：</label><span>{detailData.pullmanName || '-'}</span></p>
                            <p><label>整单发货：</label><span>{detailData.wholeDelivery == 'Y' ? '是' : '否'}</span></p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="信用情况" bordered={false} noHovering={true}>
                            <p><label>可用余额：</label><span>{detailData.remainingSum}</span></p>
                            <p>
                                <label>开单折扣率：</label><span>{detailData.discountRate || '-'}</span>
                            </p>
                            <p><label>付款方式：</label><span>{detailData.creditExtensionMode}</span></p>
                            <p><label>质保金：</label><span>{detailData.guaranteeQuality || '-'}</span></p>
                            <p>
                                <label>合同/订单名称：</label><span>{detailData.contractOrderName || '-'}</span>
                            </p>
                            <p><label>特价单号：</label><span>{/*<Button size={'small'} style={{marginLeft: '-20px'}}
                                                                onClick={this.openSpecialModal.bind(this)}>*/}{detailData.specialOfferCode || '-'}</span>
                            </p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="项目订单属性" bordered={false} noHovering={true}>
                            <p><label>项目合作：</label><span>{detailData.projectCooperation || '-'}</span></p>
                            <p><label>终端单位名称：</label><span>{detailData.completeFactory || '-'}</span></p>
                            <p><label>结算对应号：</label><span>{detailData.closeHomologous || '-'}</span></p>
                            <p><label>终端附加信息：</label><span>{detailData.projectAddMsg || '-'}</span></p>
                            <p>
                                <label>出库单显示单价：</label><span>{detailData.deliveryShowprice == 'Y' ? '是' : '否'}</span>
                            </p>
                            <p style={{display: detailData.channelCode == 'DL' ? 'inline-block' : 'none'}}>
                                <label>电力业务类别：</label><span>{detailData.dlType == 'A' ? '电力配套业务' : (detailData.dlType == 'B' ? '电力招投标业务' : (detailData.dlType == 'C' ? '电力业扩业务' : '-'))}</span>
                            </p>
                            {/*<p style={{display: (detailData.channelCode == 'PC' || detailData.channelCode == 'FX') ? 'inline-block' : 'none'}}>*/}
                            <p>
                                <label>拉动渠道：</label><span>{this.state.pullChannel || '-'}</span>
                            </p>
                            <p>
                                <label>是否托管订单：</label><span>{detailData.escrowFlag == '1' ? '是' : '否'}</span>
                            </p>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <hr style={{marginTop: '5px'}}/>
                        <Card bordered={false} noHovering={true}>
                            <p>
                                <label>实际收货地址：</label><span>{detailData.gatherRealityAddress}</span><label
                                style={{paddingLeft: '30px'}}>联系人：</label><span>{detailData.contacts || '-'}</span><label
                                style={{paddingLeft: '30px'}}>联系电话：</label><span>{detailData.phone || '-'}</span>
                            </p>
                            <p><label>备注：</label><span>{detailData.remark || '-'}</span></p>
                            <p><label>订单反馈信息：</label>
                                <span>{detailData.approvalMsg || '-'}</span></p>
                            {/*<p>
                                <label>招投标合同扫描件：</label><span>{detailData.fileUrls && detailData.fileUrls.length > 0 ? detailData.fileUrls.map(item =>
                                <a href={config.server + item.filePath} download={item.fileName}
                                   key={item.id}>{item.fileName}</a>) : null}</span></p>*/}
                        </Card>
                    </Col>
                </Row>
                <div className="tab_individual order_other">
                    <Tabs className="my-ant-tabs" defaultActiveKey={defaultActiveKey + ''}
                          onChange={self.tabClickFn.bind(self)}>
                        <TabPane tab="订单详情" key="1">
                            <div>
                                <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <Row gutter={16} style={{marginBottom: '15px'}}>
                                        <Col span={12}>
                                            隐藏列：
                                            <Select
                                                mode="multiple"
                                                placeholder="选择需要隐藏的列"
                                                style={{width: '400px'}}
                                                onChange={(val) => this.setState({hideColum: val})}>
                                                {productColum.map(x => <Option key={x.value}>{x.text}</Option>)}
                                            </Select></Col>
                                        <Col span={12}>
                                            <Input.Search placeholder="输入产品名称或编码"
                                                          onSearch={(val) => this.setState({filterKeyword: val})}/>
                                        </Col>

                                    </Row>
                                    <Table {...productProps} bordered pagination={true}/>
                                </div>
                                <div className="order_amount">
                                    {/*<p><span className="right">终端价汇总：¥{formatMoney(detailData.amount || 0)}</span></p>*/}
                                    <p><span
                                        className="right">审核终端价汇总：<font>¥{detailData.listAmount ? formatMoney(detailData.sellinAmount || 0) : formatMoney(detailData.realityAmount || 0)}</font></span>
                                    </p>
                                </div>
                            </div>
                            <div style={{borderTop: '1px solid #ddd'}}>
                                <DmsTab className="white-bg no-border" options={['招投标审核信息']}
                                        defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <div className="order_detail">
                                        <div className="opt">
                                            {orderRecordHtml}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{borderTop: '1px solid #ddd', height: '300px', background: '#fff'}}>
                                <DmsTab className="white-bg no-border" options={['订单二维码']} defaultKey={0}></DmsTab>
                                <div className="qrCode" style={{height: '300px', background: '#fff'}}>
                                    <img width="15%" height="auto" alt="订单二维码"
                                         src={window.localStorage.getItem('server') +
                                             '/api/v1/dms/tgOrder/qrCode?id=' + this.props.routeParams.orderId}/>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="发货记录" key="2" disabled={detailData.status == 1 ? true : false}>
                            <div style={{'display': detailData.escrowFlag == '1' ? 'bold' : 'none'}}>
                                <DmsTab className="white-bg no-border" options={['托管未发']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <TableView {...escrowProps} />
                                </div>
                            </div>
                            <div style={{'display': detailData.escrowFlag == '1' ? 'bold' : 'none'}}>
                                <DmsTab className="white-bg no-border" options={['托管已发']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <TableView {...escrowDetailProps} />
                                </div>
                            </div>
                            <div>
                                <DmsTab className="white-bg no-border" options={['待发货']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <TableView {...shippedProps} />
                                </div>
                            </div>
                            <div>
                                <DmsTab className="white-bg no-border" options={['已发货']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <TableView {...stayProps} />
                                </div>
                            </div>
                            <div>
                                <DmsTab className="white-bg no-border" options={['已取消']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <TableView {...cancelProps} />
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                    <div className="line-b"></div>
                    <div className="line-c" style={{left: ((defaultActiveKey - 1) * 150 + 10) + 'px'}}></div>
                </div>
            </div>
            <Modal
                visible={visibleSend}
                title="创建发货单"
                onOk={this.handleSendOk.bind(this)}
                onCancel={this.handleSendCancel.bind(this)}
                width={'80%'}
                footer={[
                    <Button key="back" size="large"
                            onClick={self.handleSendCancel.bind(this)}>取消</Button>,
                    <Button key="submit" type="primary" size="large" loading={loadingSend}
                            onClick={self.handleSendOk.bind(this)}>
                        确认发货
                    </Button>
                ]}
            >
                <div>
                    <DmsTab className="white-bg no-border" options={['发货单信息']} defaultKey={0}></DmsTab>
                    <div className="com_detail">
                        <div>
                            <p><label>发货单</label><span>{sendData.code}</span></p>
                            <p><label>客户名称</label><span>{detailData.customerName}</span></p>
                            <p><label>收货人</label><span>{detailData.receiverName} {detailData.receiverMobile}</span>
                            </p>
                        </div>
                        <div>
                            <p><label>订单编号</label><span>{detailData.code}</span></p>
                            <p><label>配送方式</label><span>{detailData.deliverTypeText}</span></p>
                            <p><label>收货地址</label><span>{detailData.receiverAddress}</span></p>
                        </div>
                    </div>
                </div>
                <div style={{borderTop: '1px solid #ddd'}}>
                    <DmsTab className="white-bg no-border" options={['发货清单']} defaultKey={0}></DmsTab>
                    <div className="dms-table-box">
                        <Table {...sendProps} bordered pagination={false}/>
                    </div>
                </div>
                <div style={{borderTop: '1px solid #ddd'}}>
                    <DmsTab className="white-bg no-border" options={['物流信息']} defaultKey={0}></DmsTab>
                    <div className="com_detail">
                        <div>
                            <Select value={sendData.logisticsCompany}
                                    onChange={this.changeInputSendFn.bind(this, -1, 'logisticsCompany')} showSearch
                                    style={{width: '90%'}} placeholder="请选择物流公司">
                                {logisticsHtml}
                            </Select>
                        </div>
                        <div>
                            <Input type="text" value={sendData.logisticsCode}
                                   onChange={this.changeInputSendFn.bind(this, -1, 'logisticsCode')}
                                   style={{width: '90%'}}
                                   placeholder="请输入物流单号"/>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                visible={visibleApprove}
                title="订单审核"
                onOk={this.handleApproveOk.bind(this)}
                onCancel={this.handleApproveCancel.bind(this)}
                width={'80%'}
                footer={[
                    <Button key="back" size="large"
                            onClick={self.handleApproveCancel.bind(this)}>取消</Button>,
                    <Button key="submit" type="primary" size="large" loading={loadingApprove}
                            onClick={self.handleApproveOk.bind(this)}>
                        确认
                    </Button>
                ]}
            >
                <div className="approve_modal">
                    <label>审核意见</label>
                    <div>
                        <Switch checkedChildren="同意" unCheckedChildren="拒绝"
                                onChange={this.changeApproveFn.bind(this, 'auditOpinion')}
                                checked={approveData.auditOpinion ? true : false}/>
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px'}}>
                    <label>备注</label>
                    <div>
                        <Input.TextArea placeholder="请输入备注" value={approveData.auditRemark}
                                        onChange={this.changeApproveFn.bind(this, 'auditRemark')}
                                        autosize={{minRows: 2, maxRows: 6}}/>
                    </div>
                </div>
            </Modal>
            <Modal
                visible={visibleConfirmPay}
                title="收款确认"
                onOk={this.handleConfirmPayOk.bind(this)}
                onCancel={this.handleConfirmPayCancel.bind(this)}
                width={'80%'}
                footer={[
                    <Button key="back" size="large"
                            onClick={self.handleConfirmPayCancel.bind(this)}>取消</Button>,
                    <Button key="submit" type="primary" size="large" loading={loadingConfirmPay}
                            onClick={self.handleConfirmPayOk.bind(this)}>
                        确认
                    </Button>
                ]}
            >
                <div className="approve_modal"
                     style={{marginTop: '20px', display: payProveData.length > 0 ? 'block' : 'none'}}>
                    <label>收款凭证</label>
                    <div className="prove">
                        {payProveHtml}
                    </div>
                </div>
                <div className="approve_modal" style={{marginTop: '20px'}}>
                    <label>确认金额<span>*</span></label>
                    <div>
                        <Input placeholder="请输入确认金额" type="number" value={confirmPayData.confirmAmount}
                               onChange={this.changeConfirmPayFn.bind(this, 'confirmAmount')}/>
                    </div>
                </div>
            </Modal>
            <Modal title="分批发运详情"
                   visible={partialShipment.visible}
                   onOk={() => {
                       this.handleOk()
                   }}
                   onCancel={() => {
                       this.handleOk()
                   }}>
                <Table {...partialShipmentProps} bordered pagination={partialShipmentPagination}/>
            </Modal>
            <Modal
                visible={visible4}
                title="特价"
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
                onCancel={this.addSaveHandler4.bind(this)}
            >
                <div>
                    <div className="dms-table-box" style={{padding: '0'}}>
                        <div className="order_detail">
                                    <span style={{paddingBottom: '0'}}>
                                    <p><label>项目编号:   &nbsp;&nbsp;</label><span>{specialHeadData.contractOrderCode}</span></p>
                                    <p><label>开单折扣比例:   &nbsp;&nbsp;</label><span>{specialHeadData.zkbl}</span></p>
                                    <p><label>差价给予类型:   &nbsp;&nbsp;</label><span>{specialHeadData.cjgyfs}</span></p>
                                    </span>
                            <span style={{paddingBottom: '0'}}>
                                    <p><label>项目名称:   &nbsp;&nbsp;</label><span>{specialHeadData.contractOrderName}</span></p>
                                    <p><label>服务费比例:   &nbsp;&nbsp;</label><span>{specialHeadData.fwfbl}</span></p>
                                    <p><label>销售合同号:   &nbsp;&nbsp;</label><span>{specialHeadData.xshtNumber}</span></p>
                                    </span>
                            <span style={{paddingBottom: '0'}}>
                                    <p><label>项目终端价格申请编号:   &nbsp;&nbsp;</label><span>{this.state.detailData.specialOfferCode}</span></p>
                                    <p><label>服务费比例确认协议编号:   &nbsp;&nbsp;</label><span>{specialHeadData.fwbm}</span></p>
                                    <p><label></label><span></span></p>
                                    </span>
                        </div>
                    </div>
                    <section className="section-bordered" style={{
                        marginTop: 0,
                        paddingTop: 5,
                        paddingBottom: 0
                    }}>
                        <Table {...addProps5} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler4.bind(this)}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    }
}
;
export default ProductDetail;



// WEBPACK FOOTER //
// ./src/routes/order/projectDetail.js